import type { OfflineQueueApp } from "~/helpers/offline/queueMeta";

import { type OfflineQueueRootState, selectWasRecentlyAdmitted } from "~/store/offlineQueueSlice";

interface OfflineQueueStore {
	getState: () => OfflineQueueRootState;
	subscribe: (listener: () => void) => () => void;
}

export const ENQUEUE_ACKNOWLEDGEMENT_WINDOW_MS = 1_000;

const awaitQueueEnqueue = (
	store: OfflineQueueStore,
	app: OfflineQueueApp,
	mutationName: string,
	reconciliationId: string,
	admittedSince?: number
): Promise<boolean> =>
	new Promise((resolve) => {
		const isAdmitted = selectWasRecentlyAdmitted(app, mutationName, reconciliationId, admittedSince);
		const settle = (enqueued: boolean): void => {
			clearTimeout(timeout);
			unsubscribe();
			resolve(enqueued);
		};
		const unsubscribe = store.subscribe(() => {
			if (isAdmitted(store.getState())) settle(true);
		});
		const timeout = setTimeout(() => settle(false), ENQUEUE_ACKNOWLEDGEMENT_WINDOW_MS);
		if (isAdmitted(store.getState())) settle(true);
	});

export default awaitQueueEnqueue;
